/** Global config & balance constants. Kept tiny for M1; grows with the game. */

export const DESIGN = {
  /** Logical canvas size; Phaser scales this to fit the device (letterboxed).
   *  Portrait-native: the game is a vertically-scrolling lane, so the canvas is
   *  tall (9:16). The world itself is taller still and pans/zooms within this. */
  width: 720,
  height: 1280,
} as const;

/** Fixed-step simulation: logic runs at a constant rate, decoupled from render
 *  FPS, for deterministic balance and clean speed multipliers (GAME_DESIGN §3.4). */
export const SIM = {
  hz: 30,
  get dt(): number {
    return 1 / this.hz;
  },
  /** Guard against spiral-of-death after a tab stall: cap steps per frame. */
  maxStepsPerFrame: 5,
  speeds: [1, 2, 3] as const,
} as const;

export const COLORS = {
  bgTop: 0x1b1e30,
  bgBottom: 0x2b2f4a,
  platform: 0x3b4066,
  platformEdge: 0x565d8c,
  path: 0x8a90c0,
  /** Universal deploy slot (any unit may be placed on any slot). */
  slot: 0x9aa0d0,
  slotGround: 0xc05a5a,
  slotTower: 0x5ac0a0,
  slotSupport: 0xc0a85a,
  enemy: 0xe06c6c,
  gate: 0xe0b04a,
  text: '#e8eaf6',
  accent: '#e0b04a',
} as const;
